export enum DealStatusEnum {
    Saved = 1,
    Proposed = 2,
    InProgress = 3,
    Closed = 4,
    Deleted = 5
};

export enum DealActionEnum {
    SaveNew = 1,
    Propose = 2,
    Close = 4,
    Update = 5,
    Delete = 6
};

export enum ApproverDealEnum {
    ProposingBusinessDirector = 1,
    Recipient = 2,
    ReceivingBusinessDirector = 3,  
};

export enum ResourceNames {
    USER = 'user',
    EDITOWNPROFILE = 'editownprofile',
    OFFICEMANAGER = 'officemanager',    
    ADMIN = 'admin',   
}
